module.exports = __webpack_public_path__ + "img/Butterfly_00214.e04b1710.png";